// ----------------------------------------------------------------------------
// Nombre del Programa : AgregarUsuario
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza para la vista y funciones para agregar roles a los usuarios
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './AgregarUsuario.scss';
import 'react-status-alert/dist/status-alert.css';
import { useEffect, useState } from 'react';
import { apiRequestToken } from '../../../Utilidades/apiRequest';
import { Row, Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useNavigate } from 'react-router-dom';
import { UsuarioProps } from '../../../interfaces/usuariosInterfaces';
import { RolProps } from '../../../interfaces/rolesInterfaces';
import StatusAlert, { StatusAlertService } from 'react-status-alert';

export const AgregarUsuario = () => {
  const [usuarios, setUsuarios] = useState<UsuarioProps[]>([]);
  const [roles, setRoles] = useState<RolProps[]>([]);
  const [body, setBody] = useState<any>({});
  const [RolSeleccionado, setRolSeleccionado] = useState('0');
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [cargado, setCargado] = useState<boolean>(false);
  const [recargar, setRecargar] = useState<boolean>(false);

  const navigate = useNavigate();

  useEffect(() => {
    cargarRoles();
    buscarUsuarios();
  }, []);
  useEffect(() => {
    //console.log('usuarios:', usuarios.filter(usuarios => usuarios.nombre.toUpperCase().indexOf(nombreUsuario.toUpperCase()) > -1));
  }, [recargar]);

  const cargarRoles = async () => {
    //setCargado(false);
    const response: any = await apiRequestToken({
      endpoint: 'roles',
      body,
      method: 'GET',
    }).catch(({ response }) => {
      const { data } = response;
      const noroles: RolProps[] = [];
      setRoles(noroles);
    });
    if (response.data && response.data.data) {
      setRoles(response.data.data);
    }
  };

  const buscarUsuarios = async () => {
    setCargado(false);
    const response: any = await apiRequestToken({
      endpoint: 'usuarios?workspace=1',
      body,
      method: 'GET',
    }).catch(({ response }) => {
      const { data } = response;
      //StatusAlertService.showError(data.meta.message)
      const nousuarios: UsuarioProps[] = [];
      setUsuarios(nousuarios);
      setCargado(true);
    });
    if (response.data && response.data.data) {
      setUsuarios(response.data.data);
      setCargado(true);
    }
  };

  const filtrarUsuarios = () => {
    //console.log('usuarios:', usuarios.filter(usuarios => usuarios.nombre.toUpperCase().indexOf(nombreUsuario.toUpperCase()) > -1));
  };

  const guardarUsuarios = async () => {
    if (RolSeleccionado === '0') {
      StatusAlertService.showError('Seleccione un rol');
      return;
    } else if (
      usuarios.filter((usuarios) => usuarios.seleccionado === true).length <= 0
    ) {
      StatusAlertService.showError('Seleccione al menos un usuario');
      return;
    }

    const usuariosseleccionados: UsuarioProps[] = usuarios.filter(
      (usuarios) => usuarios.seleccionado === true
    );
    usuariosseleccionados.forEach((usuario) => {
      let rol = {} as RolProps;
      rol.tiporol_id = Number(RolSeleccionado);
      usuario.tiporol_id = rol;
    });

    const response: any = await apiRequestToken({
      endpoint: 'usuarios/',
      body: usuariosseleccionados,
      method: 'POST',
    }).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      buscarUsuarios();
      setRolSeleccionado('0');
      setNombreUsuario('');
      StatusAlertService.showSuccess('Guardado Exitosamente');
    }
  };

  const enterUsuario = (target: any) => {
    if (target.key === 'Enter') {
      target.preventDefault();
      filtrarUsuarios();
    }
  };
  const handleChangeUsuario = (event: any) => {
    setNombreUsuario(event.target.value);
  };
  const onChangeCheckUsuario = (usuario: UsuarioProps) => {
    setRecargar(!recargar);
    usuario.seleccionado = !usuario.seleccionado;
  };

  return (
    <>
      <div className="m-5">
        <Row className="mb-2">
          <Col className="heading-1">Usuarios {'>'} Agregar usuarios</Col>
        </Row>
        <Row className="mt-3 agregar-usuario">
          <Col>
            <Row className="titulo">
              <Col className="heading-1">Agregar usuarios</Col>
            </Row>
            <Row className="mt-3">
              <Col sm={6} className="minimocolumna">
                <Form.Select
                  value={RolSeleccionado}
                  onChange={(e) => setRolSeleccionado(e.target.value)}
                >
                  <option value="0">Agregar como...</option>
                  {roles.length > 0 ? (
                    roles.map((rol, index) => (
                      <option key={rol.tiporol_id} value={rol.tiporol_id}>
                        {rol.nombreRol}
                      </option>
                    ))
                  ) : (
                    <option value="0"></option>
                  )}
                </Form.Select>
              </Col>
              <Col sm={6} className="minimocolumna">
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder="Buscar por nombre"
                    aria-label="Search"
                    value={nombreUsuario}
                    onKeyPress={enterUsuario}
                    onChange={handleChangeUsuario}
                  />
                  <InputGroup.Text
                    className="material-icons cursospointer"
                    onClick={() => filtrarUsuarios()}
                  >
                    search
                  </InputGroup.Text>
                </Form>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="altomaximo">
                {usuarios.filter(
                  (usuarios) =>
                    usuarios.nombre
                      .toUpperCase()
                      .indexOf(nombreUsuario.toUpperCase()) > -1
                ).length > 0 ? (
                  usuarios
                    .filter(
                      (usuarios) =>
                        usuarios.nombre
                          .toUpperCase()
                          .indexOf(nombreUsuario.toUpperCase()) > -1
                    )
                    .map((usuario, index) => (
                      <div key={usuario.idu_google}>
                        <label>
                          <input
                            className="primary checkrojo"
                            type="checkbox"
                            checked={usuario.seleccionado}
                            //onChange={(e) => usuarios[index].seleccionado = !usuarios[index].seleccionado}
                            onChange={(e) => onChangeCheckUsuario(usuario)}
                          />
                          {usuario.nombre}
                        </label>
                      </div>
                    ))
                ) : cargado ? (
                  <tr className="colorgray2">
                    <td className="nodatos    " colSpan={4}>
                      No Existen Datos
                    </td>
                  </tr>
                ) : (
                  ''
                )}
              </Col>
            </Row>
            <div className="d-flex flex-row-reverse bd-highlight mt-3">
              <Button
                variant="primary"
                className="float-end"
                onClick={() => guardarUsuarios()}
              >
                Agregar usuarios
              </Button>
              <Button
                variant="secondary"
                className="float-end me-3"
                onClick={() => navigate(-1)}
              >
                Cancelar
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
